import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, Dominios } from './types';

export const INITIAL_STATE: Dominios = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): Dominios {
	return produce(state, draft => {
		switch (action.type) {
			case Types.DOMINIOS_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.DOMINIOS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.DOMINIOS_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
